import { render, staticRenderFns } from "./AppReleasesTab.vue?vue&type=template&id=69f0fc16&scoped=true"
import script from "./AppReleasesTab.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppReleasesTab.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./AppReleasesTab.vue?vue&type=style&index=0&id=69f0fc16&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69f0fc16",
  null
  
)

export default component.exports